import type { Action } from 'redux';

// redux/exampleReducer.js
const initialState = {
  count: 0,
};

const exampleReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case 'INCREMENT_COUNTER':
      return {
        ...state,
        count: state.count + 1,
      };
    case 'DECREMENT_COUNTER':
      return {
        ...state,
        count: state.count - 1,
      };
    default:
      return state;
  }
};

export default exampleReducer;
